import type { MaintenanceEvent } from '~/api/types'
import { RailCard, SummaryRow } from './rail-card'
import { changeCategoryFor, formatDateTime } from './utils'

/** 이 대화에서 확인한 변경(유형·일시·정제된 설명)만 표시한다. 평가 메타는 좌측 카드와 중복되므로 제외. */
export function ChangeSummaryCard({
    activeEvent,
}: {
    activeEvent: MaintenanceEvent
}) {
    const refined = activeEvent.impact.refined_description?.trim()

    return (
        <RailCard title='이 대화로 확인한 변경'>
            <dl className='grid gap-2 text-sm'>
                <SummaryRow label='변경 유형'>
                    {changeCategoryFor(activeEvent.changeDescription)}
                </SummaryRow>
                <SummaryRow label='분석 일시'>
                    {formatDateTime(activeEvent.createdAt)}
                </SummaryRow>
                {refined ? (
                    <SummaryRow label='변경 요지'>{refined}</SummaryRow>
                ) : null}
            </dl>
        </RailCard>
    )
}
